export default "__VITE_ASSET__Dq$6je7d__"